import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";

// Import all slice reducers
import authReducer from "./slices/authSlice";
import productsReducer from "./slices/productsSlice";
import ordersReducer from "./slices/ordersSlice";
import customersReducer from "./slices/customersSlice";
import stockReducer from "./slices/stockSlice";
import dashboardReducer from "./slices/dashboardSlice";
import categoriesReducer from "./slices/categoriesSlice";
import brandsReducer from "./slices/brandsSlice";
import suppliersReducer from "./slices/suppliersSlice";
import adminReducer from "./slices/adminSlice";
import posReducer from "./slices/posSlice";
import toolsReducer from "./slices/toolsSlice";

// Configure the store
export const store = configureStore({
    reducer: {
        auth: authReducer,
        products: productsReducer,
        orders: ordersReducer,
        customers: customersReducer,
        stock: stockReducer,
        dashboard: dashboardReducer,
        categories: categoriesReducer,
        brands: brandsReducer,
        suppliers: suppliersReducer,
        admin: adminReducer,
        pos: posReducer,
        tools: toolsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types for serializable check
                ignoredActions: [
                    "persist/PERSIST",
                    "persist/REHYDRATE",
                    "persist/REGISTER",
                ],
                // Ignore these field paths in all actions
                ignoredActionsPaths: ["meta.arg", "payload.timestamp"],
                // Ignore these paths in the state
                ignoredPaths: ["items.dates"],
            },
        }),
    devTools: process.env.NODE_ENV !== "production",
});

// Export types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Export store
export default store;
